// account-balance.component.ts
import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentService } from '../payment.service';
import { AppStateService } from '../../../app-state.service';

@Component({
  selector: 'app-account-balance',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    CurrencyPipe,
    MatProgressSpinnerModule
  ],
  templateUrl: './account-balance.component.html',
  styleUrls: ['./account-balance.component.scss']
})
export class AccountBalanceComponent {
  clientId = '';
  patientId = '';
  accountAgingBalance: any = {};
  loading = false;
  balanceItems: any[] = [];
  showAgingDetails = false;
  
  paymentService = inject(PaymentService);
  snackBar = inject(MatSnackBar);
  appStateService = inject(AppStateService);
  
  constructor() {
    this.clientId = this.appStateService.getState().clientId || '';
    this.patientId = this.appStateService.getState().patientId || '';
    this.fetchAccountAgingBalance();
  }
  
  fetchAccountAgingBalance(): void {
    this.loading = true;
    this.paymentService.fetchAccountAgingBalances(this.clientId, this.patientId).subscribe({
      next: (data: any) => {
        this.accountAgingBalance = this.formatAccountAgingBalanceData(data);
        this.populateBalanceItems();
        this.loading = false;
      },
      error: (error) => {
        this.showError('Error fetching account balance information.');
        this.loading = false;
      }
    });
  }
  
  populateBalanceItems(): void {
    this.balanceItems = [
      { label: 'Total Charges', value: this.accountAgingBalance.Total, isTotal: false },
      { label: 'Insurance Coverage (Est.)', value: this.accountAgingBalance.InsEst, isTotal: false },
      { label: 'Your Responsibility', value: this.accountAgingBalance.PatEstBal, isTotal: true }
    ];
  }
  
  formatAccountAgingBalanceData(data: any): any {
    return {
      Bal_0_30: data.Bal_0_30 || 0.00,
      Bal_31_60: data.Bal_31_60 || 0.00,
      Bal_61_90: data.Bal_61_90 || 0.00,
      BalOver90: data.BalOver90 || 0.00,
      Total: data.Total || 0.00,
      InsEst: data.InsEst || 0.00,
      EstBal: data.EstBal || 0.00,
      PatEstBal: data.PatEstBal || 0.00,
      Unearned: data.Unearned || 0.00
    };
  }
  
  toggleAgingDetails(): void {
    this.showAgingDetails = !this.showAgingDetails;
  }
  
  showError(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
    });
  }
}